/**
 * Utilidades de rollback para anulación de guías
 * 
 * Provee funciones para llamar directamente a las APIs de anulación
 * sin pasar por los thunks de Redux que tienen toast notifications integradas.
 * Esto permite un rollback silencioso durante el flujo de error.
 */

import { cancelWarehouseGuide as cancelWarehouseGuideApi } from '../../../../helpers/warehouseGuide/backend_helper';

/**
 * Anula una war_guide directamente sin mostrar toasts
 * @param {string} guideId - ID de la guía a anular
 * @param {string} reason - Razón de la anulación
 * @returns {Promise} - Resultado de la API
 */
export async function rollbackWarGuide(guideId, reason) {
    return await cancelWarehouseGuideApi(guideId, {
        guide_id: guideId,
        cancellation_reason: reason,
    });
}
